import { GA_TRACKING_ID } from './config';
import type { AnalyticsEvent, PageView } from './types';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const initializeGA = () => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure'
  });
};

export const trackPageView = ({ path, title, search }: PageView) => {
  if (!window.gtag) return;

  window.gtag('config', GA_TRACKING_ID, {
    page_path: path,
    page_title: title,
    page_location: `${window.location.origin}${path}${search || ''}`
  });
};

export const trackEvent = ({ action, category, label, value }: AnalyticsEvent) => {
  if (!window.gtag) return;

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};